import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import Title from 'components/UI/Title';
import BookingTabs from 'components/BusinessLogic/Booking/BookingTabs';
import ReservationsTable from 'components/BusinessLogic/Reservation/ReservationsTable/Loadable';
import Skeleton from 'components/UI/Skeleton';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { keys } from 'lodash';
import moment from 'moment';
import { CONSTANTS } from 'services/constants';

function ReservationsTablePage({ isB2cPage })
{
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const getParsedParam = (paramIndex) =>
    {
        const result = queryParams.get(paramIndex);
        if (!result || result === 'undefined' || result === 'null')
        {
            return null;
        }

        if (paramIndex === 'checkinAfter' || paramIndex === 'checkinBefore')
        {
            return moment(result, CONSTANTS.FORMATS.QUERY_DATE).toDate();
        }

        if (paramIndex === 'checkoutBefore')
        {
            return moment(result, CONSTANTS.FORMATS.QUERY_DATE).toDate();
        }

        if (paramIndex === 'status')
        {
            result.split(',');
        }

        return result;
    };

    const initialFilters = {
        checkinAfter: getParsedParam('checkinAfter'), // prefer null over undefined
        checkinBefore: getParsedParam('checkinBefore'),
        checkoutBefore: getParsedParam('checkoutBefore'),
        bookingDateAfter: getParsedParam('bookingDateAfter'),
        bookingHotel: getParsedParam('bookingHotel'),
        sortBy: getParsedParam('sortBy') ?? 'Creation Date',
        sortByOrder: getParsedParam('sortByOrder') ?? 'desc',
        status: getParsedParam('status') ?? ['Pending', 'Booked'],
    };

    const [filters, setFilters] = useState(initialFilters);

    const updateQueryParam = (params) =>
    {
        const searchParams = new URLSearchParams(location.search);
        keys(params).forEach((mergedKey) =>
        {
            let parsedParam = params[mergedKey];
            if (parsedParam instanceof Date)
            {
                parsedParam = moment(parsedParam).format(CONSTANTS.FORMATS.QUERY_DATE);
            }

            searchParams.set(mergedKey, parsedParam);
        });
        navigate(`${location.pathname}?${searchParams.toString()}`, {
            replace: true,
            preventScrollReset: true,
        });
    };

    const onFiltersUpdate = (result) =>
    {
        const merged = { ...filters, ...result };
        merged.sortBy = merged.sortBy?.value;
        setFilters(merged);
    };

    useEffect(() =>
    {
        updateQueryParam(filters);
    }, [filters]);

    return (
        <div className="tw-flex tw-flex-col tw-flex-1 tw-w-full h-full tw-overflow-y-auto tw-p-10 lg:tw-pl-[248px] max-sm:tw-p-2 max-sm:tw-pt-10">
            <Title title="My Bookings" type="primary" icon={faCalendarDay}></Title>
            <BookingTabs onFiltersUpdate={(tabFilters) => onFiltersUpdate(tabFilters)} initialFilters={initialFilters} />

            <ReservationsTable
                fallback={<Skeleton type="table" className="tw-bg-white tw-p-10" />}
                className="tw-mt-4cd hom"
                checkinAfter={filters.checkinAfter}
                checkinBefore={filters.checkinBefore}
                checkoutBefore={filters.checkoutBefore}
                bookingDateAfter={filters.bookingDateAfter}
                bookingHotel={filters.bookingHotel}
                sortBy={filters.sortBy}
                sortByOrder={filters.sortByOrder}
                status={filters.status}
                actions
            />

            <Helmet title={`Bookings | ${isB2cPage ? 'Luxuria Vacations' : 'UJV'}`}>
                <meta name="description" content="Bookings" />
            </Helmet>
        </div>
    );
}
ReservationsTablePage.defaultProps = {
    isB2cPage: false,
};

ReservationsTablePage.propTypes = {
    isB2cPage: PropTypes.bool,
};

export default ReservationsTablePage;
